import { render, staticRenderFns } from "./PickupDetail.vue?vue&type=template&id=7c3a4f20"
import script from "./PickupDetail.vue?vue&type=script&lang=js"
export * from "./PickupDetail.vue?vue&type=script&lang=js"
import style0 from "./PickupDetail.vue?vue&type=style&index=0&id=7c3a4f20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports